// PROPERLY WORKING CODE STARTS

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../navbar/Navbar";
import LinkToRegistration from "./LinkToRegistration";
import Stepper from "../../Stepper/component/Stepper";

import {
  completeStep,
  nextStep,
  goToStep,
  prevStep,
  resetStep,
} from "../../Stepper/stepperSlice";
import DatePicker from "react-datepicker";

import {
  fetchDistrictData,
  fetchSROData,
  fetchPaymentMode,
  fetchRegistrationFee,
  fetchStampDuty,
  insertPropertyEvalData,
  insertStampRegFeeData,
  selectPdEId,
} from "../propertySlice";

import {
  fetchLoggedInUserInfoAsync,
  selectUserEvaluations,
  selectLatestEvaluation,
  selectPDEInfo,
  fetchPDEInfoAsync,
} from "../../../features/user/userSlice";
import { selectLoggedInUser } from "../../auth/authSlice";
import { updatePropertyEvaluationForm } from "../inputFieldSlices/propertyEvaluationInputSlice";
import { fetchPDEInfo } from "../../user/userAPI";
import VirtualOrPhysicalModal from "../../modal/VirtualOrPhysicalModal";
import { selectPropertyMod } from "../../Modify/ModifySlice";
import { toast } from "react-toastify";

const PropertyEvaluation = () => {
  const dispatch = useDispatch();
  const evaluations = useSelector(selectUserEvaluations);
  const latestEvaluation = useSelector(selectLatestEvaluation);
  const { pdE_ID } = useSelector((state) => state.property);
  const pdeInfo = useSelector(selectPDEInfo);
  const pdeData = pdeInfo?.pdeData[0];
  const propertyMod = useSelector(selectPropertyMod);
  const PaymentStatus = pdeInfo?.paymentStatus[0];
  const rfeeStatus = PaymentStatus?.rfeeStatus;
  const StampStatus = PaymentStatus?.stampStatus;
  const {
    districtOptions,
    sroOptions,
    paymentOptions,
    registrationFeeOptions,
    stampDutyOptions,
    insertedStampRegFeeData,
  } = useSelector((state) => state.property);

  const error = useSelector((state) => state.property.error);
  const [advance, setadvance] = useState("");
  const [Pagdi, setPagdi] = useState("");
  const [dwrname, setdwrname] = useState("");
  const [transvalue, settransvalue] = useState(0);
  const [modePayment, setmodePayment] = useState(null);
  const [ElectricityConnection, setElectricityConnection] = useState("");
  const [WaterConnection, setWaterConnection] = useState("");
  const [exedate, setexedate] = useState(null);
  const [page, setPage] = useState("");
  const [word, setword] = useState("");
  const [regfeeMin, setRegfeeMin] = useState(null);
  const [regfeeMax, setRegfeeMax] = useState(null);
  const [regPct, setRegPct] = useState(null);
  const [minstamp, setminstamp] = useState(null);
  const [stamppct, setstamppct] = useState(null);
  const [maxstamp, setmaxstamp] = useState(null);
  const [leasePeriod, setleasePeriod] = useState(0);
  const [avgRent, setavgRent] = useState(0);
  const [mvalue, setmvalue] = useState(0);
  const [rfee, setrfee] = useState(0);
  const [stampduty, setstamp] = useState("");
  const [landcost, setlandcost] = useState(0);
  const [structcost, setstructcost] = useState(0);
  const [selectedSRO, setSelectedSRO] = useState("");
  const location = useLocation();
  const currentStep = useSelector((state) => state.stepper.currentStep);
  const [isModalVisible, setModalVisible] = useState(false);
  const user = useSelector(selectLoggedInUser);
  const navigate = useNavigate();
  const today = new Date().toISOString().split("T")[0];
  const [error1, setError1] = useState("");
  debugger;
  useEffect(() => {
    if (pdE_ID) {
      dispatch(fetchPDEInfoAsync(pdE_ID));
    }
  }, [dispatch, pdE_ID]);
  useEffect(() => {
    if (latestEvaluation) {
    }
  }, [latestEvaluation]);

  useEffect(() => {
    dispatch(
      fetchRegistrationFee({
        deedcode: pdeData?.deedcode,
        subDeedCode: pdeData?.subDeedCode,
      })
    );
    dispatch(
      fetchStampDuty({
        deedcode: pdeData?.deedcode,
        subDeedCode: pdeData?.subDeedCode,
      })
    );
    dispatch(fetchPaymentMode());
  }, [dispatch, pdeData?.deedcode]);

  const handleCalculate = async () => {
    try {
      const regFeeData = {
        deedCode: pdeData?.deedcode,
        subDeedCode: pdeData?.subDeedCode,
        transValue: parseInt(transvalue), // Example: replace with your state value
        femaleBuyer: pdeData?.femaleBuyer,
        disablePerson: pdeData?.disableFlag,
        coOwner: pdeData?.coOwnerFlag,
        coOwnerNo: pdeData?.coOwnerNo, // Example: replace with your state value
        leasePeriod: parseInt(leasePeriod), // Example: replace with your state value
        averageRent: parseInt(avgRent), // Example: replace with your state value
        advance: parseInt(advance), // Example: replace with your state value
        armyPerson: pdeData?.armyFlag,
        rate: parseInt(pdeData?.circle_rate), // Example: replace with your state value
        twoPointFivePer: "N",
        roadSide: 0, // Example: replace with your state value
        floorLevel: pdeData?.floorno ? pdeData?.floorno.toString() : "", // Example: replace with your state value
        area: pdeData?.area, // Example: replace with your state value
        structValue: 0,
      };
      // Call insertStampRegFeeData API
      const response = await dispatch(insertStampRegFeeData(regFeeData));
      if (response.meta.requestStatus === "fulfilled") {
        const { mvalue, rfee, stamp, landvalue } =
          response.payload.stampRfeeResponseItem;
        setmvalue(mvalue);
        setrfee(rfee);
        setstamp(stamp);
        setlandcost(landvalue);
      }
    } catch (error) {
      console.error("Error calculating stamp and registration duty:", error);
    }
  };

  useEffect(() => {
    if (registrationFeeOptions && registrationFeeOptions.length > 0) {
      setRegfeeMin(registrationFeeOptions[0].minregfee);
      setRegfeeMax(registrationFeeOptions[0].maxregfee);
      setRegPct(registrationFeeOptions[0].regpct);
    } else {
      console.warn("Registration fee options are not available");
    }

    if (stampDutyOptions && stampDutyOptions.length > 0) {
      setminstamp(stampDutyOptions[0].minstamp);
      setmaxstamp(stampDutyOptions[0].maxstamp);
      setstamppct(stampDutyOptions[0].stamppct);
    } else {
      console.warn("Stamp duty options are not available");
    }
  }, [registrationFeeOptions, stampDutyOptions]);

  const handleSave = async () => {
    // Define required fields and labels for error messages

    try {
      const propertyEvalData = {
        preRegID: pdeData?.pdE_ID,
        advance: parseFloat(advance),
        leasePeriod: parseInt(leasePeriod),
        avgRent: parseInt(avgRent),
        transvalue: transvalue,
        modePayment: modePayment,
        exeDate: exedate,
        dwrName: dwrname,
        mValue: mvalue,
        landCost: landcost,
        structCost: structcost,
        stampDuty: isNaN(parseInt(pdeData?.bookno === 1 ? stampduty : maxstamp))
          ? 0
          : parseInt(pdeData?.bookno === 1 ? stampduty : maxstamp),
        rFee: isNaN(parseInt(pdeData?.bookno === 1 ? rfee : regfeeMax))
          ? 0
          : parseInt(pdeData?.bookno === 1 ? rfee : regfeeMax),
        page: page,
        word: word,
      };
      const formData = {
        advance,
        Pagdi,
        dwrname,
        transvalue,
        modePayment,
        ElectricityConnection,
        exedate: exedate ? exedate.toISOString().split("T")[0] : null,
        page,
        word,
        regfeeMin,
        regfeeMax,
        regPct,
        minstamp,
        stamppct,
        maxstamp,
        leasePeriod,
        avgRent,
        mvalue,
        rfee,
        stampduty,
        landcost,
        structcost,
        selectedSRO,
      };

      if (
        (pdeData && pdeData.bookno === 1) ||
        (pdeData && pdeData.deedcode === "23")
      ) {
        const requiredFields = [
          { field: "transvalue", label: "transvalue" },
          { field: "modePayment", label: "modePayment" },
          { field: "exedate", label: "exedate" },
          { field: "dwrname", label: "dwrname" },
          { field: "page", label: "page" },
          { field: "word", label: "word" },
        ];

        // Check for missing fields
        const missingFields = requiredFields.filter(
          ({ field }) => !formData[field]
        );
        if (missingFields.length > 0) {
          // Show error message for each missing required field
          const fieldNames = missingFields.map(({ label }) => label).join(", ");
          toast.warning(`Please fill in the required fields: ${fieldNames}`);
          // setIsLoading(false);
          return;
        }
      } else {
        const requiredFields = [
          { field: "page", label: "page" },
          { field: "word", label: "word" },
        ];

        // Check for missing fields
        const missingFields = requiredFields.filter(
          ({ field }) => !formData[field]
        );
        if (missingFields.length > 0) {
          // Show error message for each missing required field
          const fieldNames = missingFields.map(({ label }) => label).join(", ");
          toast.warning(`Please fill in the required fields: ${fieldNames}`);
          // setIsLoading(false);
          return;
        }
      }
      // Save form data to session storage
      sessionStorage.setItem("propertyEvalFormData", JSON.stringify(formData));
      const response = await dispatch(insertPropertyEvalData(propertyEvalData));
      if (response.meta.requestStatus === "fulfilled") {
        const dataResp = response.payload[0];
        const pde_id = dataResp.pdE_ID;
        // alert(" Property Eval Data inserted successfully");
        toast.success("Property evaluation saved successfully!");
        setModalVisible(true);
        await dispatch(nextStep());
        await dispatch(completeStep({ step: 2, completed: true }));
      } else {
        console.error("Failed to insert user");
      }
    } catch (error) {
      console.error("An error occurred:", error);
      toast.error("Failed to save property evaluation.");
    }
  };
  useEffect(() => {
    debugger;
    // Load form data from local storage
    const storedFormData = sessionStorage.getItem("propertyEvalFormData");

    if (storedFormData) {
      debugger;
      const parsedFormData = JSON.parse(storedFormData);
      // Update component state with parsedFormData
      setadvance(parsedFormData.advance);
      setPagdi(parsedFormData.Pagdi);
      setdwrname(parsedFormData.dwrname);
      settransvalue(parsedFormData.transvalue);
      setmodePayment(parsedFormData.modePayment);
      setElectricityConnection(parsedFormData.ElectricityConnection);
      // setexedate(parsedFormData.exedate);
      if (parsedFormData.exedate) {
        setexedate(new Date(parsedFormData.exedate));
      }
      setPage(parsedFormData.page);
      setword(parsedFormData.word);
      setRegfeeMin(parsedFormData.regfeeMin);
      setRegfeeMax(parsedFormData.regfeeMax);
      setRegPct(parsedFormData.regPct);
      setminstamp(parsedFormData.minstamp);
      setstamppct(parsedFormData.stamppct);
      setmaxstamp(parsedFormData.maxstamp);
      setleasePeriod(parsedFormData.leasePeriod);
      setavgRent(parsedFormData.avgRent);
      setmvalue(parsedFormData.mvalue);
      setrfee(parsedFormData.rfee);
      setstamp(parsedFormData.stampduty);
      setlandcost(parsedFormData.landcost);
      setstructcost(parsedFormData.structcost);
      setSelectedSRO(parsedFormData.selectedSRO);
    }
  }, []);

  // Trial for even number of pages

  const validateEvenNumber = (value) => {
    // Ensure the input is a non-zero, even, and at least 10
    return (
      value !== "" &&
      value !== "0" &&
      Number(value) >= 10 &&
      Number(value) % 2 === 0
    );
  };

  const handlePageChange = (e) => {
    const value = e.target.value;
    setPage(value); // Temporarily set value without validation
  };

  const handlePageBlur = () => {
    if (!validateEvenNumber(page)) {
      setPage(""); // Reset the page value
      toast.error(
        "Page must be a non-zero even number greater than or equal to 10"
      );
    }
  };

  return (
    <>
      <Navbar />
      <LinkToRegistration />
      {/* <div className="flex min-h-screen"> */}
      <div className="flex flex-grow">
        <div className="w-1/5 bg-white py-4 flex justify-center">
          <Stepper />
        </div>
        <div className="w-0.5 border-none bg-neutral-400"></div>
        <div className="w-4/5 flex justify-center">
          <div className="w-full  py-6 bg-white rounded-lg">
            <div className="space-y-4">
              {pdeData && pdeData.bookno === 1 ? (
                <>
                  <div className="grid gap-4 m-8 md:grid-cols-12 grid-cols-2 items-center">
                    <label className="block w-full relative text-sm font-semibold md:col-span-2 grid-cols-1">
                      advance/Security:
                    </label>
                    <div className="block w-full relative md:col-span-4 grid-cols-1">
                      <input
                        type="text"
                        id="advance"
                        value={advance}
                        onChange={(e) => {
                          const value = e.target.value;
                          setadvance(value);
                        }}
                        disabled={
                          propertyMod &&
                          (rfeeStatus === "SUCCESS" ||
                            StampStatus === "SUCCESS")
                        }
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>

                    <label className="block w-full relative text-sm font-semibold md:col-span-2 grid-cols-1">
                      Premium/Pagdi:
                    </label>
                    <div className="block w-full relative md:col-span-4 grid-cols-1">
                      <input
                        type="text"
                        id="Pagdi"
                        value={Pagdi}
                        onChange={(e) => {
                          const value = e.target.value;
                          setPagdi(value);
                        }}
                        className="block w-full pl-2 pr-8 py-1.5 border-none shadow-sm bg-gray-100 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>
                  {pdeData && pdeData.deedcode === "08" ? (
                    <div className="grid gap-4 m-8 md:grid-cols-12 grid-cols-2 items-center">
                      <label className="block w-full relative text-sm font-semibold md:col-span-2 grid-cols-1">
                        Lease Period:
                      </label>
                      <div className="block w-full relative md:col-span-4 grid-cols-1">
                        <input
                          type="text"
                          id="leasePeriod"
                          value={leasePeriod}
                          onChange={(e) => {
                            const value = e.target.value;
                            setleasePeriod(value);
                          }}
                          disabled={
                            propertyMod &&
                            (rfeeStatus === "SUCCESS" ||
                              StampStatus === "SUCCESS")
                          }
                          className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          required
                        />
                        <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                      </div>
                      <label className="block w-full relative text-sm font-semibold md:col-span-2 grid-cols-1">
                        Average rent (per month):
                      </label>
                      <div className="block w-full relative md:col-span-4 grid-cols-1">
                        <input
                          type="text"
                          id="avgRent"
                          value={avgRent}
                          onChange={(e) => {
                            const value = e.target.value;
                            setavgRent(value);
                          }}
                          disabled={
                            propertyMod &&
                            (rfeeStatus === "SUCCESS" ||
                              StampStatus === "SUCCESS")
                          }
                          className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          required
                        />
                        <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                      </div>
                    </div>
                  ) : null}

                  <div className="grid gap-4 m-8 md:grid-cols-12 grid-cols-2 items-center">
                    <label className="block w-full relative text-sm font-semibold md:col-span-2 grid-cols-1">
                      transvalue Value:
                    </label>
                    <div className="block w-full relative md:col-span-4 grid-cols-1">
                      <input
                        type="text"
                        id="transvalue"
                        value={transvalue}
                        onChange={(e) => {
                          const value = e.target.value;
                          settransvalue(value);
                        }}
                        disabled={
                          propertyMod &&
                          (rfeeStatus === "SUCCESS" ||
                            StampStatus === "SUCCESS")
                        }
                        className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>

                    <label className="block w-full relative text-sm font-semibold md:col-span-2 grid-cols-1">
                      Mode Of Payment:
                    </label>
                    <div className="block w-full relative md:col-span-4 grid-cols-1">
                      <select
                        value={modePayment}
                        onChange={(e) => setmodePayment(e.target.value)}
                        disabled={
                          propertyMod &&
                          (rfeeStatus === "SUCCESS" ||
                            StampStatus === "SUCCESS")
                        }
                        className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      >
                        {/* <option value="">Mode Of Payment</option> */}
                        {paymentOptions.map((option) => (
                          <option
                            key={option.payment_code}
                            value={option.payment_code}
                          >
                            {option.payment_type}
                          </option>
                        ))}
                      </select>
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>

                  <div className="grid gap-4 m-8 md:grid-cols-12 grid-cols-2 items-center">
                    <label className="block w-full relative text-sm font-semibold md:col-span-2 grid-cols-1">
                      Execution Date:
                    </label>
                    <div className="block w-full relative md:col-span-4 grid-cols-1">
                      <input
                        type="date"
                        value={
                          exedate ? exedate.toISOString().split("T")[0] : null
                        }
                        onChange={(e) => setexedate(new Date(e.target.value))}
                        id="date"
                        min={today}
                        className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      />
                      <hr className="absolute left-0 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>

                    <label className="block w-full relative text-sm font-semibold md:col-span-2 grid-cols-1">
                      Deed Writer/Adv Name:
                    </label>
                    <div className="block w-full relative md:col-span-4 grid-cols-1">
                      <input
                        type="text"
                        id="Deed Writer"
                        value={dwrname}
                        onChange={(e) => {
                          const value = e.target.value;
                          setdwrname(value);
                        }}
                        className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        required
                      />
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>

                  <div className="flex justify-between items-center"></div>

                  <div className="flex justify-center items-center mt-5">
                    <button
                      className="px-6 py-2 bg-blue-500 text-white rounded-full text-sm"
                      onClick={handleCalculate}
                    >
                      Calculate Stamp and Registration Duty
                    </button>
                  </div>
                </>
              ) : null}

              {pdeData && pdeData.deedcode === "23" ? (
                <>
                  <div className="flex justify-between items-center space-x-2 px-8">
                    <h1
                      className="text-slate-800"
                      style={{ fontWeight: "bold" }}
                    >
                      Mussana Office Details for Appointment
                    </h1>
                  </div>
                  <div className="grid gap-4 m-8 md:grid-cols-12 grid-cols-2 items-center">
                    <label className="block w-full relative text-sm font-semibold md:col-span-2 grid-cols-1">
                      SRO:
                    </label>
                    <div className="block w-full relative md:col-span-4 grid-cols-1">
                      <select
                        value={selectedSRO}
                        onChange={(e) => setSelectedSRO(e.target.value)}
                        className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100  shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      >
                        <option value="">SRO</option>
                        {sroOptions.map((option) => (
                          <option key={option.sroCode} value={option.sroCode}>
                            {option.sroName}
                          </option>
                        ))}
                      </select>
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>

                    <label className="block w-full relative text-sm font-semibold md:col-span-2 grid-cols-1">
                      Mode Of Payment:
                    </label>
                    <div className="block w-full relative md:col-span-4 grid-cols-1">
                      <select
                        value={modePayment}
                        onChange={(e) => setmodePayment(e.target.value)}
                        disabled={
                          propertyMod &&
                          (rfeeStatus === "SUCCESS" ||
                            StampStatus === "SUCCESS")
                        }
                        className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      >
                        {/* <option value="">Mode Of Payment</option> */}
                        {paymentOptions.map((option) => (
                          <option
                            key={option.payment_code}
                            value={option.payment_code}
                          >
                            {option.payment_type}
                          </option>
                        ))}
                      </select>
                      <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                    </div>
                  </div>
                </>
              ) : null}

              <div className="flex justify-between items-center"></div>

              <div className="grid gap-4 m-8 md:grid-cols-12 grid-cols-2 items-center">
                <label className="block w-full relative text-sm font-semibold md:col-span-2 grid-cols-1">
                  Electricity Connection Name Change Required:
                </label>
                <div className="block w-full relative md:col-span-4 grid-cols-1">
                  <select
                    id="ElectricityConnection"
                    value={ElectricityConnection}
                    onChange={(e) => setElectricityConnection(e.target.value)}
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    required
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
                <label className="block w-full relative text-sm font-semibold md:col-span-2 grid-cols-1">
                  Water Connection Name Change Required:
                </label>
                <div className="block w-full relative md:col-span-4 grid-cols-1">
                  <select
                    id="WaterConnection"
                    value={WaterConnection}
                    onChange={(e) => setWaterConnection(e.target.value)}
                    className="block w-full pl-2 pr-8 py-1.5 border-none bg-gray-100 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    required
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                  <hr className="absolute left-0 px-2 bottom-0 w-full h-0.5 border-none bg-gray-500" />
                </div>
              </div>

              <div className="flex justify-between items-center"></div>
              <hr className=" h-0.5 border-none bg-neutral-400" />

              <div className="space-y-4 px-8 md:px-32">
                <h1 className="text-slate-800 font-bold">
                  FEES / STAMP DUTY DETAILS
                </h1>

                {/* {pdeData ? (
                  <>
                    <div className="grid md:grid-cols-2 gap-4">
                      <div className="flex justify-between text-sm">
                        <span>Circle Rate:</span>
                        <span className="text-blue-600">
                          {"₹ " + (pdeData?.circle_rate ?? "₹ " + 0)}
                        </span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span>Govt. Value:</span>
                        <span className="text-blue-600">
                          {mvalue !== null ? "₹ " + mvalue : "₹ " + 0}
                        </span>
                      </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-4">
                      <div className="flex justify-between text-sm">
                        <span>Land / Floor Value:</span>
                        <span className="text-blue-600">
                          {landcost !== null ? "₹ " + landcost : "₹ " + 0}
                        </span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span>Structure Value:</span>
                        <span className="text-blue-600">
                          {structcost !== null ? "₹ " + structcost : "₹ " + 0}
                        </span>
                      </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-4">
                      <div className="flex justify-between text-sm">
                        <span>Total Stamp Duty:</span>
                        <span className="text-blue-600 justify-self-start">
                          ₹
                          {pdeData?.bookno === 1
                            ? stampduty ?? 0
                            : maxstamp ?? 0}
                        </span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span>Registration Fees:</span>
                        <span className="text-blue-600 justify-self-start">
                          ₹ {pdeData?.bookno === 1 ? rfee ?? 0 : regfeeMax ?? 0}
                        </span>
                      </div>
                    </div>
                  </>
                ) : null} */}

                {pdeData ? (
                  <>
                    <div className="grid md:grid-cols-2 gap-4">
                      <div className="flex justify-between text-sm">
                        <span>Circle Rate:</span>
                        <span className="text-blue-600">
                          {"₹ " + (pdeData?.circle_rate ?? "₹ " + 0)}
                        </span>
                      </div>
                      <div className="flex justify-between items-center text-sm">
                        <span>Govt. Value:</span>
                        <input
                          type="number"
                          step="any"
                          value={mvalue}
                          onChange={(e) => setmvalue(e.target.value)}
                          className="w-3/6 pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-blue-600"
                        />
                      </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-4">
                      <div className="flex justify-between items-center text-sm">
                        <span>Land / Floor Value:</span>
                        <input
                          type="number"
                          step="any"
                          value={landcost}
                          onChange={(e) => setlandcost(e.target.value)}
                          className="w-3/6 pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-blue-600"
                        />
                      </div>
                      <div className="flex justify-between items-center text-sm">
                        <span>Structure Value:</span>
                        <input
                          type="number"
                          step="any"
                          value={structcost}
                          onChange={(e) => setstructcost(e.target.value)}
                          className="w-3/6 pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-blue-600"
                        />
                      </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-4">
                      <div className="flex justify-between items-center text-sm">
                        <span>Total Stamp Duty:</span>
                        {pdeData.bookno === 1 ? (
                          <input
                            type="number"
                            step="any"
                            value={stampduty}
                            onChange={(e) => setstamp(e.target.value)}
                            className="w-3/6 pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-blue-600"
                          />
                        ) : (
                          <input
                            type="number"
                            step="any"
                            value={maxstamp}
                            onChange={(e) => setmaxstamp(e.target.value)}
                            className="w-3/6 pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-blue-600"
                          />
                        )}
                      </div>
                      <div className="flex justify-between items-center text-sm">
                        <span>Registration Fees:</span>
                        {pdeData.bookno === 1 ? (
                          <input
                            type="number"
                            step="any"
                            value={rfee}
                            onChange={(e) => setrfee(e.target.value)}
                            className="w-3/6 pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-blue-600"
                          />
                        ) : (
                          <input
                            type="number"
                            step="any"
                            value={regfeeMax}
                            onChange={(e) => setRegfeeMax(e.target.value)}
                            className="w-3/6 pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm text-blue-600"
                          />
                        )}
                      </div>
                    </div>
                  </>
                ) : null}

                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex justify-between items-center text-sm">
                    <span>Total Pages:</span>
                    {/* <input
                      type="text"
                      id="page"
                      value={page}
                      onChange={(e) => setPage(e.target.value)}
                      className="w-3/6 pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      required
                    /> */}
                    {/* Trial for even number of pages STARTS */}
                    <input
                      type="number"
                      id="page"
                      value={page}
                      onChange={handlePageChange}
                      onBlur={handlePageBlur} // Validate only on blur
                      className="w-3/6 pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      required
                      min="10" // Optional: restricts the input to non-negative numbers
                      step="1" // Optional: allows whole numbers only
                    />
                    {/* Trial for even number of pages ENDS */}
                  </div>

                  <div className="flex justify-between items-center text-sm">
                    <span>Total Words in deed:</span>
                    <input
                      type="number"
                      id="word"
                      value={word}
                      onChange={(e) => setword(e.target.value)}
                      className="w-3/6 pl-2 pr-8 py-1.5 border border-gray-300 shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="flex justify-between items-center"></div>
              <hr className=" h-0.5 border-none bg-neutral-400" />

              <div className="flex justify-center mt-5">
                <button
                  className="px-6 py-2 bg-blue-500 text-white rounded-full text-md"
                  onClick={handleSave}
                >
                  Save & Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModalVisible && <VirtualOrPhysicalModal />}
    </>
  );
};

export default PropertyEvaluation;

// PROPERLY WORKING CODE ENDS
